import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react"
import { useClientTheme } from "@/app/components/ThemeContext"
import type { SortDir } from "@/app/hooks/useTableSort"

export interface SortOption {
  key: string
  label: string
}

interface MobileSortSelectProps {
  options: SortOption[]
  sortKey: string | null
  sortDir: SortDir
  // Pass the table's handleSort — selecting a field sorts asc; tapping the
  // direction toggle re-sorts the active field to flip direction.
  onSort: (key: string) => void
}

// Sort control for card (mobile) mode, where column headers aren't clickable.
export function MobileSortSelect({ options, sortKey, sortDir, onSort }: MobileSortSelectProps) {
  const { theme } = useClientTheme()

  return (
    <div
      className="flex items-center gap-2 px-4 py-3"
      style={{ borderBottom: `1px solid ${theme.borderColor}`, backgroundColor: theme.bgSurface2 }}
    >
      <ArrowUpDown size={14} style={{ color: theme.textMuted, flexShrink: 0 }} />
      <span
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: "12px",
          fontWeight: 500,
          color: theme.textMuted,
          flexShrink: 0,
        }}
      >
        Sort
      </span>
      <select
        value={sortKey ?? ""}
        onChange={(e) => e.target.value && onSort(e.target.value)}
        className="flex-1 rounded-lg px-2.5"
        style={{
          height: "34px",
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
          color: theme.textPrimary,
          backgroundColor: theme.bgSurface,
          border: `1px solid ${theme.borderColor}`,
        }}
      >
        <option value="" disabled>
          Choose field…
        </option>
        {options.map((o) => (
          <option key={o.key} value={o.key}>
            {o.label}
          </option>
        ))}
      </select>
      <button
        onClick={() => sortKey && onSort(sortKey)}
        disabled={!sortKey}
        aria-label="Toggle sort direction"
        className="flex items-center justify-center rounded-lg flex-shrink-0"
        style={{
          width: "34px",
          height: "34px",
          color: sortKey ? theme.brandAccent : theme.textDim,
          backgroundColor: theme.bgSurface,
          border: `1px solid ${theme.borderColor}`,
          opacity: sortKey ? 1 : 0.5,
        }}
      >
        {sortDir === "asc" ? <ArrowUp size={15} /> : <ArrowDown size={15} />}
      </button>
    </div>
  )
}
